import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import {
	Card,
	CardBody,
	CardHeader,
} from "@tql/ui-components-react/kendo/layout";
import { Button } from "@tql/ui-components-react/tql/buttons";
import {
	refreshCcw_01,
	shieldTick,
} from "@tql/ui-components-react/untitled/icons";
import { useState } from "react";

import type { ShipmentInsuranceOrPayVendor } from "~/shared/schemas/shipment-management-schema";
import { formatCurrency } from "~/shared/utils/string-fns.ts";

import { AddShipmentInsuranceModal } from "../add-shipment-insurance-modal/add-shipment-insurance-modal.tsx";

export const InsuranceCard = ({
	details,
	insuredAmount,
	isInsured,
	quoteId,
	poNumber,
	loadValue,
	onRerate,
}: {
	details?: ShipmentInsuranceOrPayVendor;
	insuredAmount?: number;
	isInsured?: boolean;
	quoteId?: number;
	poNumber?: number;
	loadValue?: number | null;
	onRerate?: () => void;
}) => {
	const [showInsuranceModal, setShowInsuranceModal] = useState(false);

	const insuredValue = Number(insuredAmount ?? 0);
	const displayedInsuredValue = Number(details?.totalAmount ?? insuredValue);
	const displayedIsInsured = isInsured ?? displayedInsuredValue > 0;

	return (
		<div
			className={"half-size-card"}
			data-testid={"shipment-management-insurance"}
		>
			<Card className={"full-height shipment-info-card"}>
				<CardHeader>
					<h3>Insurance</h3>
				</CardHeader>
				<CardBody>
					{displayedIsInsured ? (
						<div className={"insurance-details insurance-details-insured"}>
							<div className={"info-field"}>
								<div
									className={"section-label info-label-with-icon"}
									data-testid={"insurance-status"}
								>
									<SvgIcon icon={shieldTick} themeColor={"primary"} />
									Insured Amount
								</div>
								<div
									className={"insurance-insured-value"}
									data-testid={"insurance-total-amount"}
								>
									{formatCurrency(displayedInsuredValue)}
								</div>
							</div>
							<div className={"info-field"}>
								<div className={"section-label"}>Shipment Value</div>
								<div>{formatCurrency(Number(loadValue ?? 0))}</div>
							</div>
						</div>
					) : (
						<div className={"insurance-details"}>
							<div className={"info-field"}>
								<div className={"section-label"}>Shipment Value ($)</div>
								<div>{formatCurrency(Number(loadValue ?? 0))}</div>
							</div>
							<Button
								onClick={onRerate}
								startIcon={<SvgIcon icon={refreshCcw_01} />}
								variant={"tertiary"}
							>
								Rerate to Add Insurance
							</Button>
						</div>
					)}
				</CardBody>
			</Card>
			<AddShipmentInsuranceModal
				defaultShipmentValue={insuredAmount ?? 0}
				onClose={() => setShowInsuranceModal(false)}
				poNumber={poNumber ?? 0}
				quoteId={quoteId ?? 0}
				showModal={showInsuranceModal}
			/>
		</div>
	);
};
